import React, { useRef, useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import './UploadInvoice.css';
import NavBar from "../Navbar/Navbar";
import Header from '../Header/Header';
import { useUser } from '../UserContext';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, showLoading } from '../store/loadingSlice';
import { useTranslation } from "react-i18next";
import * as pdfjsLib from 'pdfjs-dist';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf';

// Ορίζουμε τον worker src στο CDN
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.worker.min.js`;

function UploadInvoice() {
  //cancel api calls
  const [abortController, setAbortController] = useState(null);

  const { t } = useTranslation();
  const [isNavOpen, setIsNavOpen] = useState(true);
  const { username, companyName } = useUser();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);
  const licenseData = useSelector((state) => state.liscence.modules);
  const [selectedFileName, setSelectedFileName] = useState('Δεν επιλέγθηκε κανένα αρχείο');
  //////////////Select series consts/////////////////////
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState(1251);

  //Editable table of Invoice
  const [payload, setPayload] = useState(null);
  const [viewMode, setViewMode] = useState('table');
  const [isEditing, setIsEditing] = useState(false);
  const [items, setItems] = useState([]);
  const [tempJson, setTempJson] = useState(JSON.stringify(payload?.data, null, 2));
  const [jsonError, setJsonError] = useState("");
  //const [sitmisi, setSitmisi] = useState("");
  //αριθμός σελίδων του pdf
  const [pageCount, setPageCount] = useState(null);
  //keep me in the same line of the table
  const tableRef = useRef(null);
  
  //Αν φύγει από την σελίδα, ακυρώνεται η κλήση setdata του παραστατικού
  useEffect(() => {
    const controller = new AbortController();
    setAbortController(controller);
  
    return () => {
      controller.abort();
      dispatch(hideLoading()); // ακύρωση όταν φύγεις ή κάνεις refresh
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const parameters = {
        url: `https://${licenseData.company_url}/s1services`,
        service: "getBrowserInfo",
        clientID: localStorage.getItem("token"),
        appId: licenseData.appid,
        OBJECT: "SERIES",
        LIST: "",
        VERSION: 2,
        LIMIT: 1000,
        FILTERS: `SERIES.SOSOURCE=${selectedCategoryCode}`
      };
      try {
        const response = await axiosInstance.post("/api", parameters);

        if (response.data.success) {
          const rows = response.data.rows || [];
          setItems(rows);
          // Ορίζουμε την 2062 ως default αν υπάρχει στη λίστα
          const defaultItem = rows.find((row) => row[2] === "2062");
          setSelectedItemCode(defaultItem ? "2062" : rows.length > 0 ? rows[0][2] : null);
        }
      } catch (error) {
        console.error('API error:', error);
        setItems([]);
      }
    };

    fetchData();
  }, [selectedCategoryCode]);

  // useEffect για την ενημέρωση του sitmisi όταν αλλάζει το selectedItemCode
  /*useEffect(() => {
    if (selectedItemCode && items.length > 0) {
      const selectedRow = items.find((row) => row[2] === selectedItemCode);
      setSitmisi(selectedRow ? selectedRow[3] : "");
    } else {
      setSitmisi("");
    }
  }, [selectedItemCode, items]);*/

  /////////////////////////////////////////////////////

  const extractaApiUrl = process.env.REACT_APP_EXTRACTA_API_URL;
  const xitClientID = process.env.REACT_APP_XIT_CLIENT_ID;
  

  ///const extractionId = "-OQ8Lr8kNT8pe79MALI0";
  console.log(licenseData.extracta_id);
  const extractionId = licenseData.extracta_id;

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const fetchExtractaBatchResults = async (payload) => {
    const maxRetries = 25; // Number of attempts
    const delay = 10000; // 10 seconds between attempts
    let attempt = 0;

    while (attempt < maxRetries) {
      try {
        // Fetch batch results
        const response = await axiosInstance.post("/extracta", payload);

        const { status, data } = response;
        if (status === 200 && data) {
          if (status === 200 && data.status === "waiting") {
            console.log(`Attempt ${attempt + 1}: Processing still waiting...`);
            await new Promise((resolve) => setTimeout(resolve, delay)); // Wait before retrying
          } else {
            return data; // Return data on completed
          }
        } else {
          console.error("Unexpected status:", data);
          break; // Exit on unexpected status
        }
      } catch (error) {
        console.error("Error fetching batch results:", error.message);
        break; // Exit on error
      }

      attempt++;
    }

    console.error("Exceeded maximum retries. Batch processing not completed.");
    return null; // Return null
  }

  // Function to fetch TRDR using VAT number from the invoice data
  const fetchSupplierTRDR = async (vat) => {
    // Fetch TRDR if VAT is available
    if (vat) {
      const parameters = {
        url: `https://${licenseData.company_url}/s1services`,
        service: "getBrowserInfo",
        clientID: localStorage.getItem("token"),
        appId: licenseData.appid,
        OBJECT: "SUPPLIER",
        LIST: "",
        VERSION: 2,
        LIMIT: 1,
        FILTERS: `SUPPLIER.AFM=${vat}`
      };

      try {
        const response = await axiosInstance.post("/api", parameters);
        if (response.data.success && response.data.rows && response.data.rows.length > 0) {
          const value = response.data.rows[0][0];
          const trdrId = value.match(/(\d+)$/) ? value.match(/(\d+)$/)[0] : null; // Extract the TRDR
          return trdrId;
        } else {
          console.error('Δεν Βρέθηκε ο Πελάτης.', response.data);
          return null;
        }
      } catch (error) {
        console.error('Δεν Βρέθηκε ο Πελάτης:', error);
        return null;
      }
    } else {
      console.log("Δεν Βρέθηκε ΑΦΜ στο Τιμολόγιο.");
      return null;
    }
  };

  const handleFileUpload = async (apiType) => {
    const file = fileInputRef.current?.files[0];
    if (!file) {
      alert("Παρακαλώ να επιλέξετε αρχείο PDF.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result);
      try {
        const pdf = await getDocument(typedArray).promise;
        console.log(`Το PDF έχει ${pdf.numPages} σελίδες.`);
        setPageCount(pdf.numPages); 
      } catch (error) {
        console.error('Σφάλμα κατά την ανάγνωση του PDF:', error);
      }
    };
    reader.readAsArrayBuffer(file);

    dispatch(showLoading());

    try {
      let invoiceData;
      if (apiType === "veryfi") {
        invoiceData = await handleVeryfiUpload(file);
      } else if (apiType === "extracta") {
        invoiceData = await handleExtractaUpload(file, abortController?.signal);
      }

      if (!invoiceData) return;

      // Fetch TRDR using VAT Number
      const trdr = await fetchSupplierTRDR(invoiceData.merchantTaxId);
      if (!trdr) {
        alert("Δεν Βρέθηκε ο πελάτης στο Softone.");
        return;
      }
      //format date
      let  vTrndate=invoiceData.invoiceDate;
      const dotFormatRegex = /^\d{2}\.\d{2}\.\d{4}$/; // Matches DD.MM.YYYY
      if (dotFormatRegex.test(vTrndate)) {
        vTrndate=convertDate(invoiceData.invoiceDate);
      }
      console.log(vTrndate);
      // Prepare transformed data
      const transformedData = prepareTransformedData(invoiceData, trdr, vTrndate);
      console.log(transformedData);
      setPayload(transformedData);
      if (transformedData?.data) {
        setTempJson(JSON.stringify(transformedData.data, null, 2));
      }

      console.log(JSON.stringify(transformedData.data, null, 2));
      //καταχώρηση αναλώσεων πόντων του extracta

      setViewMode('table'); 
      setIsEditing(true); // Allow editing of payload
      alert("Επιτυχής Υποβολή PDF!");

    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        console.log("✅ Κλήση ακυρώθηκε λόγω αποχώρησης.");
      } else {
        alert("Σφάλμα στην υποβολή PDF!");
        console.error("Error processing invoice:", error);
      }
      setPayload(null);
      setTempJson(null);
      setIsEditing(false);
    } finally {
      dispatch(hideLoading());
    }
  };

  const analosiExtracta = async (batchId) => {
    const getDate = new Date();
    //κλήση στην βάση της XIT
      const parameters = {
        url: `xit.oncloud.gr/s1services`,
        service: "setData",
        clientID: xitClientID,
        appId: "1001",
        OBJECT: "CCCOEINVOICEAI",
        KEY: "",
        OBJECTPARAMS: { IMPORT: 1 },
        data: {
          CCCEINVOICEAI: [
            {
              documentid: batchId,
              pages: pageCount,
              issuedate: getDate,
              CustomerAFM: licenseData.afm,
              Extraction: licenseData.extracta_id
            }
          ]
        }
      };

      try {
        const response = await axiosInstance.post("/api", parameters);
        if (response.data.success && response.data.rows && response.data.rows.length > 0) {
          console.log('Επιτυχημένη καταχώρηση ανάλωσης', response.data);
        } else {
          console.log('Σφάλμα στην καταχώρηση της ανάλωσης', response.data);
          return null;
        }
      } catch (error) {
        console.log('Σφάλμα στην καταχώρηση της ανάλωσης:', error);
        return null;
      }
  };

  const handleVeryfiUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const uploadResponse = await axiosInstance.post("/veryfi", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });

      if (uploadResponse.data && uploadResponse.data.status === "fail") {
        alert(uploadResponse.data.error);
        return null;
      }

      const invoiceData = mapVeryfiResponse(uploadResponse.data);
      console.log("Veryfi Invoice Data:", invoiceData);
      return invoiceData;
    } catch (error) {
      console.error("Veryfi API error:", error);
      alert(`Veryfi API Error: ${error.message}`);
      return null;
    }
  };

  const mapVeryfiResponse = (invoiceData) => {
    return {
      invoiceNumber: invoiceData.invoice_number || "Unknown",
      clientTaxId: invoiceData.vendor?.vat_number || "",
      invoiceDate: invoiceData.date || "Unknown",
      invoiceTotal: invoiceData.total || "0.00",
      clientAddress: invoiceData.ship_to?.address || "GIANNARI 4",
      lineItems: (invoiceData.line_items || []).length.toString(),
      items: (invoiceData.line_items || []).map((item) => ({
        sku: item.sku || item.reference || "9999",
        comment: item.text || item.description || "",
        quantity: (item.quantity || 1).toString(),
        discount: item.discount || "0.00",
        unitPrice: (item.price || 0).toFixed(2),
        totalPrice:(item.total || 0) // || ((item.quantity || 1) * (item.price || 0)).toFixed(2)
      })),
    };
  };

  const handleExtractaUpload = async (file, signal) => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("extractionId", extractionId);
    formData.append("url", `${extractaApiUrl}/uploadFiles`);

    try {
      const uploadResponse = await axiosInstance.post("/extracta", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        signal: signal
      });

      if (uploadResponse.data && uploadResponse.data.status === "error") {
        alert(uploadResponse.data.message);
        return null;
      }

      if (
        !uploadResponse.data ||
        !uploadResponse.data.batchId ||
        !uploadResponse.data.files ||
        uploadResponse.data.files.length === 0
      ) {
        console.error("Failed to upload file to Extracta");
        alert("Σφάλμα στην ανάγνωση του παραστατικού");
        return null;
      }

      const batchId = uploadResponse.data.batchId;
      const fileId = uploadResponse.data.files[0].fileId;


      const resultsPayload = {
        extractionId,
        batchId,
        fileId,
        url: `${extractaApiUrl}/getBatchResults`
      };

      const resultsResponse = await fetchExtractaBatchResults(
        resultsPayload
      );

      const { files } = resultsResponse;
      if (!files || files.length === 0) {
        alert("Δεν Έχει Υποβληθεί Κανένα Αρχείο.");
        return null;
      }

      const extractedFile = files[0];
      if (extractedFile.status !== "processed") {
        alert(`Το Αρχείο Δεν Υποβλήθηκε: ${extractedFile.status}`);
        return null;
      }

      const { result } = extractedFile;
      const invoiceData = mapExtractaResponse(result);

      console.log("Extracta Invoice Data:", invoiceData);
      let analosi;
      analosi = await analosiExtracta(batchId);
      return invoiceData;
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        console.log("✅ Upload ακυρώθηκε (unmount ή refresh).");
      } else {
        alert(`Σφάλμα στην ανάγνωση του παραστατικού: ${error.message}`);
        console.error("Extracta API error:", error.message);
      }
      return null;
    }
  };

  function parseLocalizedNumber(value) {
    if (typeof value !== 'string') return null;
  
    // Step 1: Trim spaces
    let cleaned = value.trim();
  
    // Step 2: Remove all spaces inside the string (sometimes thousands separator can be space)
    cleaned = cleaned.replace(/\s/g, '');
  
    // Step 3: If there are both dots and commas, assume dots are thousand separators and commas decimal
    if (cleaned.indexOf('.') > -1 && cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    }
    // Step 4: If only commas exist, treat comma as decimal separator
    else if (cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(',', '.');
    }
    // Step 5: If only dots exist, treat dot as decimal separator (US style)
    // So do nothing to cleaned
  
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
  }

  const mapExtractaResponse = (invoiceData) => {
    return {
      clientAddress: invoiceData.client?.client_address || "Unknown",
      clientTaxId: invoiceData.client?.client_tax_id || "",
      invoiceNumber: `${invoiceData.Document_Series ? invoiceData.Document_Series + ' ' : ""}${invoiceData.invoice_id || 'Unknown'}`,
      invoiceDate: invoiceData.invoice_date || "Unknown", 
      invoicecomments: `${invoiceData.invoice_end_user || ""} - ${invoiceData.invoice_comments || ""}`,
      invoiceremarks: invoiceData.invoice_end_user || "",
      invoiceTotal: parseLocalizedNumber(invoiceData.invoice_grand_total),
      items:
        invoiceData.items?.map((item) => {
          const parsedPrice = parseLocalizedNumber(item.total_price);
          return {
            ///code: item.code|| "9999",
            CCCXITCHECKEXISTENCESKU: null,
            sku: item.sku || "9999",
            comment: item.name,
            quantity: parseInt(item.quantity || 1),
            unitPrice: parseFloat((item.unit_price || "0,00").replace(',', '.')).toString(),  
            tax: item.tax,
            discount1: parseFloat(item.discount_1_value || 0),
            discount2: parseFloat(item.discount_2_value || 0),
            discount3: parseFloat(item.discount_3_value || 0), 
            totalPrice: parsedPrice !== null ? parsedPrice.toFixed(2) : null,
          };
        }) || [],
      merchantTaxId: invoiceData.merchant?.merchant_tax_id || null,
      merchantaddress: invoiceData.merchant?.merchant_address || null,
      shippingaddress: invoiceData.shipping_address|| "Unknown"
    };
  };

  const prepareTransformedData = (invoiceData, trdr, vTrndate) => ({
    url: `https://${licenseData.company_url}/s1services`,
    service: "setData",
    clientID: localStorage.getItem("token"),
    appId: licenseData.appid,
    OBJECT: "PURDOC",
    KEY: "",
    data: {
      PURDOC: [
        {
          SERIES: selectedItemCode,
          CMPFINCODE: invoiceData.invoiceNumber,
          TRNDATE: vTrndate,
          TRDR: trdr,
          PAYMENT: 1003,
          SHIPMENT: "1000",
          COMMENTS: invoiceData.invoicecomments,
          REMARKS: invoiceData.invoiceremarks,
          SUMAMNT: invoiceData.invoiceTotal,
          line_items: (invoiceData.items || []).length.toString(),
        },
      ],
      MTRDOC: [
        {
          SHIPPINGADDR: invoiceData.shippingaddress,
        },
      ],
      ITELINES: invoiceData.items?.map((item, index) => ({
        LINENUM: index,
        ///SRCHCODE: item.code,
        SRCHCODE: item.sku,
        QTY1: item.quantity,
        PRICE: item.unitPrice,
        DISC1PRC: item.discount1,
        DISC2PRC: item.discount2,
        DISC3PRC: item.discount3,
        COMMENTS: item.comment,
        SCODE: item.sku,
        CCCXITCHECKEXISTENCESKU: item.CCCXITCHECKEXISTENCESKU
        //LINEVAL: item.totalPrice,
      })) || [],
    },
  });

  const checkItemExistance = async (sku) => {
    const parameters = {
      url: `https://${licenseData.company_url}/s1services`,
      service: "sqlData",
      clientID: localStorage.getItem("token"),
      appId: licenseData.appid,
      SqlName: "9600",
      company: licenseData.company_id,
      sku : sku,
    };
    try {
      const response = await axiosInstance.post("/api", parameters);
      const rows = response.data?.totalcount;
      console.log(sku+': '+rows);
      return rows > 0;
    } catch (error) {
      console.error('API error:', error);
    }
};

const checkAllItemsExistence = async () => {
  if (!tempJson) return;

  dispatch(showLoading());

  try {
    const currentData = JSON.parse(tempJson);
    
    // Δημιουργούμε ένα νέο array με updated exists
    const updatedItems = await Promise.all(
      currentData.ITELINES.map(async (item) => {
        const ifExists = await checkItemExistance(item.SCODE);
        return {
          ...item,
          CCCXITCHECKEXISTENCESKU: ifExists ? "✓" : "✗"
        };
      })
    );

    // Δημιουργούμε το νέο payload με τα ενημερωμένα ITELINES
    const newData = {
      ...currentData,
      ITELINES: updatedItems
    };
    console.log(newData);
    setTempJson(JSON.stringify(newData, null, 2));
  } catch (error) {
    alert("Σφάλμα κατά τον έλεγχο barcode.");
    console.error(error);
  } finally {
    dispatch(hideLoading());
  }
};

  const handleJsonChange = (e) => {
    const inputValue = e.target.value;
    setTempJson(inputValue);
  
    try {
      JSON.parse(inputValue);
      setJsonError("");
    } catch (error) {
      setJsonError("Invalid JSON format! Please fix it.");
    }
  };

  const handleRepost = async () => {
    if (!tempJson) {
      alert("Δεν Έχουν Υποβληθεί Δεδομένα.");
      return;
    }
  
    try {
      const parsedData = JSON.parse(tempJson);
      
      // Update payload state with modified data
      setPayload((prevPayload) => ({ 
        ...prevPayload, 
        data: parsedData 
      }));
  
      dispatch(showLoading());
      
      // Send updated payload to API
      const response = await axiosInstance.post("/api", { 
        ...payload, 
        data: parsedData 
      });
  
      if (response.data.success) {
        alert("Επιτυχής Δημιουργία του Παραστατικού!");
      } else {
        alert(`Σφάλμα στην Δημιουργία του Παραστατικού: ${response.data.error}`);
      }
    } catch (error) {
      console.error("Invalid JSON format:", error);
      alert("Λάθος Μορφή JSON. Παρακαλώ Διορθώστε τον Πίνακα Δεδομένων");
      setJsonError("Invalid JSON format! Please fix and try again.");
    } finally {
      dispatch(hideLoading());
    }
  };

  const TABLE_FIELD_CONFIG = {
    PURDOC: ['SERIES', 'CMPFINCODE', 'TRNDATE', 'TRDR', 'PAYMENT', 'COMMENTS', 'SUMAMNT'],
    MTRDOC: ['SHIPPINGADDR'],
    ITELINES: ['SCODE', 'QTY1', 'PRICE', 'DISC1PRC', 'DISC2PRC', 'DISC3PRC', 'COMMENTS']
  };

  const FIELD_TRANSLATIONS = {
    // Section headers
    "PURDOC": "Γενικά Στοιχεία",
    "MTRDOC": "Παράδοση Διακίνηση",
    "ITELINES": "Είδη Παραστατικού",
    "line_items":"Συνολικά Είδη",
    // Field labels
    "SERIES": "Σειρά",
    "CMPFINCODE": "Αριθμός Παραστατικού",
    "TRNDATE": "Ημερομηνία",
    "TRDR": "Προμηθευτής",
    "PAYMENT": "Τρόπος Πληρωμής",
    "SHIPMENT": "Τρόπος Αποστολής",
    "COMMENTS": "Αιτιολογία",
    "REMARKS": "Παρατηρήσεις",
    "SUMAMNT": "Συνολ.Αξία",
    "SHIPPINGADDR": "Διεύθυνση",
    "LINENUM": "Αριθμός Γραμμής",
    "SRCHCODE": "Barcode/EAN",
    "QTY1": "Ποσότητα",
    "PRICE": "Τιμή",
    "DISC1PRC": "Έκπτωση 1",
    "DISC2PRC": "Έκπτωση 2",
    "DISC3PRC": "Έκπτωση 3",
    "SCODE": "Κωδικός Αναζήτησης",
    "LINEVAL": "Τελ. Αξία Γραμμής"
  };

  const JsonTableEditor = ({ jsonData, onUpdate }) => {
    const [data, setData] = useState(jsonData);
    const [editingCell, setEditingCell] = useState(null); // {section, index, key}
    const [editValue, setEditValue] = useState("");
  
    const handleCellClick = (section, index, key, value) => {
      setEditingCell({ section, index, key });
      setEditValue(value === null ? 'null' : value);
    };
  
    const handleCellBlur = () => {
      if (!editingCell) return;
      
      const { section, index, key } = editingCell;
      const newData = JSON.parse(JSON.stringify(data));
      newData[section][index][key] = editValue === 'null' ? null : editValue;
      
      // Αν το SRCHCODE άλλαξε, ενημέρωσε και το SCODE
      if (section === "ITELINES" && key === "SCODE") {
        newData[section][index]["SRCHCODE"] = editValue;
      }

      updateMyData(newData);
      setEditingCell(null);
    };
  
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleCellBlur();
      } else if (e.key === 'Escape') {
        setEditingCell(null);
      }
    };

    //Updates Data but keep me in the same position of the table (px editing line 100 of the ITELINES)
    const updateMyData = (updatedData) => {
      const scrollTop = tableRef.current?.scrollTop || 0;
      setData(updatedData);
      onUpdate(updatedData);
      setTimeout(() => {
        if (tableRef.current) {
          tableRef.current.scrollTop = scrollTop;
        }
      }, 0);
    };
    
  
    return (
      <div className="table-container" ref={tableRef} style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        {Object.keys(data).filter(section => data[section].length > 0).map((section) => (
          <div key={section} className="mb-3" style={{textAlign: "left"}}>
            <h5 style={{
              backgroundColor: '#e6f2ff',
              padding: '8px 12px',
              borderRadius: '6px',
              color: '#004080',
              fontSize: '16px',
              marginBottom: '10px'
            }}>
              {FIELD_TRANSLATIONS[section] || section}
            </h5>
            <table className="table">
              <thead>
                <tr>
                {section === "ITELINES" && (
                  <th></th>
                )}
                  {TABLE_FIELD_CONFIG[section]?.map((key) => (
                    <th key={key} style={{ minWidth: '100px' }}>
                      {FIELD_TRANSLATIONS[key] || key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data[section].map((item, index) => (
                  <tr key={index}>
                    {section === "ITELINES" && (
                      <td 
                        className={`exists-cell ${
                        item.CCCXITCHECKEXISTENCESKU === '✓' ? 'exists-true' :
                        item.CCCXITCHECKEXISTENCESKU === '✗' ? 'exists-false' :
                        'exists-null'}`}
                      >
                        {item.CCCXITCHECKEXISTENCESKU || ''}
                      </td>
                    )}
                    {TABLE_FIELD_CONFIG[section]?.map((key) => {
                      const isEditing = editingCell?.section === section && 
                                       editingCell?.index === index && 
                                       editingCell?.key === key;
                      const value = item[key] === null ? 'null' : item[key];
                      
                      return (
                        <td 
                          key={key}
                          onClick={() => handleCellClick(section, index, key, value)}
                          style={{ cursor: 'pointer', minWidth: '100px' }}
                        >
                          {isEditing ? (
                            <input
                              type="text"
                              value={editValue}
                              onChange={(e) => setEditValue(e.target.value)}
                              onBlur={handleCellBlur}
                              onKeyDown={handleKeyDown}
                              autoFocus
                              style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                padding: '4px'
                              }}
                            />
                          ) : (
                            <div style={{ padding: '4px' }}>
                              {value}
                            </div>
                          )}
                        </td>
                      );
                    })}
                    {section === "ITELINES" && (
                    <td style={{border:"none"}}>
                      <button id="delete-itemline"
                        onClick={() => {
                          const newData = { ...data };
                          newData[section] = newData[section].filter((_, i) => i !== index);
                          newData["PURDOC"][0]["line_items"] = newData[section].length;
                          updateMyData(newData);
                        }}
                        style={{
                          color: "white",
                          backgroundColor: "red",
                          border: "none",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          cursor: "pointer"
                        }}
                      >
                        Διαγραφή
                      </button>
                    </td>
                  )}
                  </tr>
                ))}
              </tbody>
            </table>
            {section === "ITELINES" && (
                  <button id="new-itemline"
                    onClick={() => {
                      const newData = { ...data };
                      const newLineNum = newData[section].length;
                      const newRow = {
                        LINENUM: newLineNum,
                        SRCHCODE: "",
                        QTY1: 1,
                        PRICE: "0.00",
                        DISC1PRC: 0,
                        DISC2PRC: 0,
                        DISC3PRC: 0,
                        COMMENTS: "",
                        SCODE: "",
                        CCCXITCHECKEXISTENCESKU: null
                      };
                      newData[section].push(newRow);
                      newData["PURDOC"][0]["line_items"] = newData[section].length;
                      updateMyData(newData);
                    }}
                    style={{
                      marginBottom: "10px",
                      marginTop: "8px",
                      backgroundColor: "#007bff",
                      color: "white",
                      padding: "6px 12px",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer"
                    }}
                  >
                    + Νέα Γραμμή
                  </button>
                )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div id="upload-invoice-page" className={`container-upload ${isNavOpen ? 'nav-open' : 'nav-closed'}`}>
      <NavBar toggleNav={toggleNav} />
      <div className="dashboard-content">
        <Header username={username} companyName={companyName} />
        <div className="main-content">
          <h1>{t("UploadPDF")}</h1>

          <div id="div-select-series" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            background: '#f9f9f9',
            width: 'max-content'
          }}>
            <fieldset style={{ border: 'none', padding: '0', margin: '0' }}>

              <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                {/* Dropdown κατηγοριών */}
                <label style={{ fontSize: '14px', fontWeight: 'bold' }}>
                  <span style={{ paddingRight: '5px' }}>Κατηγορία: </span>
                  <select id="select-kukloma"
                    value={selectedCategoryCode}
                    onChange={(e) => setSelectedCategoryCode(Number(e.target.value))}
                    style={{
                      width: '120px',
                      padding: '6px 12px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      fontSize: '14px',
                      backgroundColor: '#fff',
                      cursor: 'pointer'
                    }}
                  >
                    <option value={1251}>Αγορές</option>
                    <option value={1253}>Δαπάνες</option>
                  </select>
                </label>

                {/* Dropdown για τα αποτελέσματα */}
                <label style={{ fontSize: '14px', fontWeight: 'bold' }}>
                  <span style={{ paddingRight: '5px' }}>Σειρά:</span>
                  <select id="select-series"
                    value={selectedItemCode || ""}
                    onChange={(e) => setSelectedItemCode(e.target.value)}
                    style={{
                      width: "200px",
                      padding: "6px 12px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "14px",
                      backgroundColor: "#fff",
                      cursor: "pointer"
                    }}
                  >
                    <option value="">Επιλέξτε...</option>
                    {items.map((row, index) => (
                      <option key={index} value={row[2]}>
                        {row[2]} - {row[4]}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </fieldset>
          </div>


          <div className="file-input-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
            {/* Visible button that triggers the hidden input */}
            <button
              className="btn-secondary"
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                backgroundColor: '#2e7d32',
                color: 'white',
                border: 'none',
                fontSize: '16px',
                fontWeight: 600,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer'
              }}
              onClick={() => fileInputRef.current.click()}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2e7d3275'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2e7d32'}
            >
              <i className="bi bi-upload"></i>
              Επιλογή Αρχείου
            </button>

            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              accept=".pdf"
              style={{ display: 'none' }}
              onClick={(e) => { e.target.value = null }}
              onChange={(e) => {
                const file = e.target.files[0];
                setSelectedFileName(file ? file.name : 'Δεν επιλέγθηκε κανένα αρχείο');
              }}
            />

            <span id="file-placeholder" style={{ marginLeft: '10px', fontWeight: '620', color: "darkgrey" }}>
                {selectedFileName}
            </span>
          </div>
          
          
          {/*<button onClick={() => handleFileUpload("veryfi")} className="btn btn-primary m-3">
            Upload to Veryfi
          </button>*/}
          <button onClick={() => handleFileUpload("extracta")} className="btn btn-secondary m-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" width="30" height="30">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M12 12v6m0 0l-3-3m3 3l3-3m0-6a4 4 0 00-8 0v1" />
          </svg>
          {t("Upload")}
          </button>
          {/* Show JSON Payload */}
          {payload && (
            <div className="mt-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>ΣΤΟΙΧΕΙΑ ΠΑΡΑΣΤΑΤΙΚΟΥ</h4>
                <div className="btn-group">
                  <button 
                    className={`btn btn-sm ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setViewMode('table')}
                  >
                    Πίνακας
                  </button>
                  <button 
                    className={`btn btn-sm ${viewMode === 'json' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setViewMode('json')}
                  >
                    JSON
                  </button>
                </div>
              </div>

              {viewMode === 'json' ? (
                <textarea
                  value={tempJson}
                  onChange={handleJsonChange}
                  rows={12}
                  cols={70}
                  className="form-control mb-3"
                  style={{
                    fontFamily: "monospace",
                    background: "#f8f9fa",
                    textAlign:'left'
                  }}
                />
              ) : (
                <JsonTableEditor 
                  jsonData={JSON.parse(tempJson)} 
                  onUpdate={(updatedData) => setTempJson(JSON.stringify(updatedData, null, 2))} 
                />
              )}

              {jsonError && <div className="alert alert-danger">{jsonError}</div>}

              {isEditing && (
                <button onClick={handleRepost} className="btn btn-success mt-3">
                  Ανέβασμα στο Softone!
                </button>
              )}
              {isEditing && (
                <button onClick={checkAllItemsExistence} className="btn btn-light btn-outline-secondary mt-3" style={{ marginLeft: '10px' }}>
                  Έλεγχος Barcode
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function convertDate(dateStr) {
  // Αντικαθιστούμε τελείες ή κάθετες με κενό χαρακτήρα για split
  const cleaned = dateStr.replace(/[./]/g, '-');
  const [day, month, year] = cleaned.split('-').map(Number);

  // Ελέγχουμε αν η ημερομηνία είναι έγκυρη
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== (month - 1) ||
    date.getDate() !== day
  ) {
    throw new Error(`Invalid date: ${dateStr}`);
  }

  const formatted = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  return formatted;
}

export default UploadInvoice;
